module.exports = __webpack_public_path__ + "img/1521061354.06bef6d0.jpg";